export default "__VITE_ASSET__cb159a37__"